import { Input } from "@/components/ui/form";
import { Button } from "@/components/ui/button";
import { TrashIcon } from "@heroicons/react/24/outline";

export const SlotTime = ({ day, index, onRemove }) => {
    return (
        <>
            <td className="px-1 py-2">
                <Input
                    name={`${day}.Times[${index}].availabilityGuid`}
                    type="hidden"
                />
                <Input
                    name={`${day}.Times[${index}].startTime`}
                    size="sm"
                    type="time"
                    label="Start time"
                    hideLabel={true}
                />
            </td>
            <td className="px-1 py-2">
                <Input
                    name={`${day}.Times[${index}].endTime`}
                    size="sm"
                    type="time"
                    label="End time"
                    hideLabel={true}
                />
            </td>
            <td className="px-1 py-2">
                <Button
                    type="button"
                    variant="danger"
                    size="sm"
                    title="Remove time slot"
                    className="px-3"
                    onClick={() => onRemove(index)}
                >
                    <TrashIcon />
                </Button>
            </td>
        </>
    );
};
